import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa';

/** Palette home (stessa del tema scuro CIL). */
export const C = {
  bg: '#16181d',
  surface: '#1e2127',
  line: 'rgba(255,255,255,0.08)',
  yellow: '#ffcc00',
  green: '#3eb297',
  blue: '#36a9e1',
  pink: '#e95995',
};

/** Etichetta di sezione: solo testo, mai un riempimento (non deve sembrare un bottone). */
export const Eyebrow = ({ children, ...rest }) => (
  <Text
    fontSize="xs"
    fontWeight="700"
    letterSpacing="0.14em"
    textTransform="uppercase"
    color={C.yellow}
    mb={2}
    {...rest}
  >
    {children}
  </Text>
);

/** Unico elemento "pieno giallo" per sezione: l'azione principale. */
export const PrimaryButton = (props) => (
  <Button
    h="48px"
    px={6}
    bg={C.yellow}
    color={C.bg}
    fontWeight="800"
    fontSize="md"
    borderRadius="8px"
    _hover={{ bg: '#ffd83a', transform: 'translateY(-1px)' }}
    transition="all 0.2s"
    {...props}
  />
);

/** Azione secondaria: testo + freccia, nessun riempimento né bordo. */
export const TextLink = ({ children, ...rest }) => (
  <Flex
    display="inline-flex"
    align="center"
    gap={1.5}
    fontWeight="700"
    color="white"
    transition="color 0.2s"
    _hover={{ color: C.yellow, '& svg': { transform: 'translateX(3px)' } }}
    {...rest}
  >
    <span>{children}</span>
    <Icon as={FaArrowRight} boxSize="12px" transition="transform 0.2s" />
  </Flex>
);

/** Ritmo verticale unico per tutte le sezioni (72px, 48px su mobile). */
export const Section = ({ children, flush, ...rest }) => (
  <Box
    as="section"
    pt={flush ? 0 : { base: 12, md: 18 }}
    pb={{ base: 12, md: 18 }}
    {...rest}
  >
    <Container maxW="1120px" px={{ base: 4, md: 8 }}>
      {children}
    </Container>
  </Box>
);

export const SectionHead = ({ eyebrow, title, subtitle, action, centered }) => (
  <Flex
    align="flex-end"
    justify={centered ? 'center' : 'space-between'}
    gap={6}
    mb={{ base: 6, md: 8 }}
  >
    <Box textAlign={centered ? 'center' : undefined}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <Heading
        as="h2"
        fontSize={{ base: '2xl', md: '3xl' }}
        fontWeight="800"
        letterSpacing="-0.02em"
      >
        {title}
      </Heading>
      {subtitle && (
        <Text
          color="gray.400"
          fontSize="lg"
          mt={2}
          maxW="56ch"
          mx={centered ? 'auto' : undefined}
        >
          {subtitle}
        </Text>
      )}
    </Box>
    {action}
  </Flex>
);
